import React from "react";
import { Row, Col, MenuItem, Nav, Navbar, NavItem, NavDropdown, Button, Panel, Grid, DropdownButton, FormGroup, FormControl } from 'react-bootstrap'
import InputNumber from 'rc-input-number';
import 'rc-input-number/assets/index.css';
import Breadcrumbing from "../Breadcrumbing/Breadcrumbing";
import Features from "../Features/Features";
import Quantity from "../Quantity/Quantity";

class Cart extends React.Component {
render() {
return (
<div className="cart">
    <Breadcrumbing />
    <Grid>
        <div className="cart-bg">
            <div className="table">
                <div className="row main header">
                    <div className="cell product">
                        Product
                    </div>
                    <div className="cell Price">
                        Price
                    </div>
                    <div className="cell Quantity">
                        Quantity
                    </div>
                    <div className="cell Total-Price">
                        Total Price
                    </div>
                    <div className="cell Action">
                        Action
                    </div>
                </div>
                {/*  You can make map from here */}
                <div className="row cart__item-one">
                    <div className="cell" data-title="Name">
                        <div className="cart-img col-md-3">
                            <span> <img src={require("../../img/cart/shirt.png")} />  </span>
                        </div>
                        <div className="cart-name col-md-9">
                            <a href="#">  Tee shirt homme manches courtes encolure gr/m2 100% coton KARIBAN K357.</a>
                            <div className="cart-category">
                                <p> Category :<span class="cart__category-type">Men - Shirts  </span></p>
                                <p> Colour :<span class="cart__colour"> Blue  </span></p>
                                <p> size :<span class="cart__size"> XXl  </span></p>
                            </div>
                        </div>
                    </div>
                    <div className="cart__price cell" data-title="Age">
                        180 EGP
                    </div>
                    <Quantity/>
                    <div className="cart__total-price cell" data-title="Location">
                        360 EGP
                    </div>
                    <div className="cart__action-control cell" data-title="">
                        <span className="cart__favorite">
                        <i class="material-icons">
                        favorite_border
                        </i>
                        </span>
                        <span className="cart__delete">
                        <i class="material-icons">
                        delete_forever
                        </i>
                        </span>
                    </div>
                </div>
               
                {/*  End map */}

                  {/*  You can make map from here */}
                  <div className="row cart__item-one">
                    <div className="cell" data-title="Name">
                        <div className="cart-img col-md-3">
                            <span> <img src={require("../../img/cart/shirt.png")} />  </span>
                        </div>
                        <div className="cart-name col-md-9">
                            <a href="#">  Tee shirt homme manches courtes encolure gr/m2 100% coton KARIBAN K357.</a>
                            <div className="cart-category">
                                <p> Category :<span class="cart__category-type">Men - Shirts  </span></p>
                                <p> Colour :<span class="cart__colour"> Blue  </span></p>
                                <p> size :<span class="cart__size"> XXl  </span></p>
                            </div>
                        </div>
                    </div>
                    <div className="cart__price cell" data-title="Age">
                        180 EGP
                    </div>
                    <div className="cart__quantity cell" data-title="Occupation">
                        <div>
                            <InputNumber
                                min={1}
                                max={10}
                                onChange={this.onChange}
                                defaultValue={1}
                                />
                        </div>
                    </div>
                    <div className="cart__total-price cell" data-title="Location">
                        360 EGP
                    </div>
                    <div className="cart__action-control cell" data-title="">
                        <span className="cart__favorite">
                        <i class="material-icons">
                        favorite_border
                        </i>
                        </span>
                        <span className="cart__delete">
                        <i class="material-icons">
                        delete_forever
                        </i>
                        </span>
                    </div>
                </div>
                {/*  End map */}
                
            </div>
        </div>
        <Col md={4}>
        <div className="cart__calucate-shipping">
            <h3 className="cart__calucate-shipping-name name-blue"> Calculate Shipping </h3>
            <Row>
                <Col md={12}>
                <DropdownButton title="Country *" id="country">
                    <MenuItem eventKey="1">Action</MenuItem>
                    <MenuItem eventKey="2">Another action</MenuItem>
                    <MenuItem eventKey="3">Something else here</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="4">Separated link</MenuItem>
                </DropdownButton>
                </Col>
                <Col md={6}>
                <DropdownButton title="City / State *" id="citystate">
                    <MenuItem eventKey="1">Action</MenuItem>
                    <MenuItem eventKey="2">Another action</MenuItem>
                    <MenuItem eventKey="3">Something else here</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="4">Separated link</MenuItem>
                </DropdownButton>
                </Col>
                <Col md={6}>
                <FormGroup controlId="formHorizontalEmail" className="zip-code">
                    <FormControl type="text" placeholder="ZIP Code *" />
                </FormGroup>
                </Col>
                <div className="cart_update">
                    <a href="/"><button type="button" class="cart_update btn  btn-blue">  Update</button></a>
                </div>
            </Row>
        </div>
        </Col>
        <Col md={4}>
        <div className="cart__calucate-shipping cart-holder">
            <h3 className="cart__calucate-shipping-name name-blue">Coupon Code</h3>
            <p className="cart__calucate-shipping-caption"> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <Row>
                <Col md={12}>
                <FormGroup controlId="formHorizontalEmail" className="addcode">
                    <FormControl type="text" placeholder="Add Code Here" />
                </FormGroup>
                </Col>
                <div className="cart_update">
                    <a href="/"><button type="button" class="cart-apply_btn btn  btn-blue">  Apply</button></a>
                </div>
            </Row>
        </div>
        </Col>
        <Col md={4}>
        <div className="Cart-total">
            <h3> Cart total : </h3>
            <Row>
                <Col md={8}>
                <p className="Cart__total-left"> Cart Sub-Total : </p>
                </Col>
                <Col md={4}>
                <p className="Cart__total-right">1440 EGP </p>
                </Col>
                <Col md={8}>
                <p className="Cart__total-left">Shipping & Handling : </p>
                </Col>
                <Col md={4}>
                <p className="Cart__total-right">FREE </p>
                </Col>
                <div className="clearfix">
                    <Col md={8}>
                    <p className="Cart__total-left"> Cart Total : </p>
                    </Col>
                    <Col md={4}>
                    <p className="Cart__total-right"> 1440 EGP </p>
                    </Col>
                </div>
                <div className="cart_proceed">
                    <a href="/checkout"><button type="button" class="cart_proceed_btn btn "> Proceed to Checkout <i class="fa fa-arrow-right"></i></button></a>
                </div>
            </Row>
        </div>
        </Col>
    </Grid>
    <Features/>

</div>
);
}
}
export default Cart;


// WEBPACK FOOTER //
// ./src/Components/Cart/Cart.jsx